import { isValidString } from "@/utils/string_formatter";
import { defineStore } from "pinia";
import { useTerminalConfigurationStore } from "@/store/common/terminal_configuration_store";

export const useImportSearchIdsStore = defineStore("importSearchIds", {
  state: (): {
    importSearchIds: string[];
    invalidFormatIds: string[];
    validIds: string[];
    invalidIds: string[];
    assetApiError: { failed: boolean; message: string; params: any };
    selectedContainers: string[];
    transactionType: string;
  } => ({
    importSearchIds: [],
    invalidFormatIds: [],
    validIds: [],
    invalidIds: [],
    assetApiError: { failed: false, message: "", params: {} },
    selectedContainers: [],
    transactionType: "PUI"
  }),
  persist: false,
  getters: {
    getImportSearchIds(): string[] {
      return this.importSearchIds ?? [];
    }
  },
  actions: {
    // Add search ids to the store searchIds array
    addImportSearchId(id: string): void {
      const config = useTerminalConfigurationStore();
      this.importSearchIds = Array.isArray(this.importSearchIds) ? this.importSearchIds : [];
      if (!this.importSearchIds.includes(id.trim()) && isValidString(id.trim())) {
        if (this.importSearchIds.length < config.searchIdLimit) {
          this.importSearchIds.push(id.trim());
        }
      }
    },

    // Remove search ids from the store searchIds array
    removeSearchId(id: string): void {
      this.importSearchIds = this.importSearchIds.filter((searchId): boolean => searchId.trim() !== id.trim());
    },

    popSearchId(): void {
      this.importSearchIds.pop();
    },

    clearSearchIds(): void {
      this.importSearchIds = [];
      this.invalidFormatIds = [];
    },

    setValidIds(ids: string[]): void {
      this.validIds = ids ? [...ids] : [];
    },

    setInvalidIds(ids: string[]): void {
      this.invalidIds = ids ? [...ids] : [];
    },

    // Set api error
    setAssetApiError(failed: boolean, message: string): void {
      this.assetApiError = { failed, message, params: {} };
    },

    // Clear the invalid ids array
    clearInvalidIds(): void {
      this.invalidIds = [];
    },

    // Clear all states
    clearAllStates(): void {
      this.invalidFormatIds = [];
      this.validIds = {};
      this.invalidIds = {};
      this.assetApiError = {};
      this.selectedContainers = {};
    }
  }
});
